var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 9007199254740991;
// 2 ** 53 - 1 == 9007199254740991
module.exports = function (it) {
    if (it > MAX_SAFE_INTEGER)
        throw $TypeError('Maximum allowed index exceeded');
    return it;
};